<template>
  <div class="row mx-0">
    <commonQueryInput
      :inputItems="multiInputItems"
      v-model:getValue="multiInputVal"
    ></commonQueryInput>
    <div class="d-flex justify-content-end text-end">
      <div
        class="py-1 px-2"
        style="background: #c8c9ca; min-width: max-content"
      >
        <span>異動人員：{{ username }}</span>
      </div>
    </div>
    <div class="col-12">
      <div
        class="table-responsive my-2"
        style="max-height: 500px"
        ref="webPageTable"
      >
        <table class="table table-style" :class="{ mod: mod }">
          <thead>
            <tr>
              <th v-if="mod"></th>
              <th colspan="3">基本資料</th>
              <th colspan="4">對應權限</th>
            </tr>
            <tr>
              <th v-if="mod">刪除</th>
              <th>編號</th>
              <th>名稱</th>
              <th>上層目錄</th>
              <th>新增</th>
              <th>查詢</th>
              <th>修改</th>
              <th>刪除</th>
            </tr>
          </thead>
          <tbody>
            <template v-if="add">
              <tr>
                <td>
                  <input
                    type="text"
                    name="webPage_id"
                    v-model="addWebPageData.webPage_id"
                    class="w-100"
                  />
                </td>
                <td>
                  <input
                    type="text"
                    name="webPageName"
                    v-model="addWebPageData.name"
                    class="w-100"
                  />
                </td>
                <td>
                  <select
                    class="w-100 text-center"
                    v-model="addWebPageData.noumenon_id"
                    name="commonSelectInput"
                    style="height: 33px"
                  >
                    <option :value="null">無</option>
                    <option
                      v-for="(option, index) in webPageOption"
                      :value="option.value"
                      :disabled="option.value == ''"
                    >
                      {{ option.text }}
                    </option>
                  </select>
                </td>
                <template v-for="rightItem in right">
                  <td
                    class="changeAccessStyle"
                    @click="changeAccess('add', index, rightItem)"
                  >
                    <template
                      v-if="addWebPageData.right.indexOf(rightItem) >= 0"
                    >
                      V
                    </template>
                  </td>
                </template>
              </tr>
            </template>
            <template v-for="(item, index) in webPage">
              <tr>
                <td v-if="mod">
                  <input
                    type="checkbox"
                    name="delCheckbox"
                    :value="item.webPage_id"
                    v-model="delCheckbox"
                  />
                </td>
                <td>{{ item.webPage_id }}</td>
                <td>
                  <template v-if="mod">
                    <input
                      type="text"
                      name="webPageName"
                      v-model="webPage[index].name"
                      class="w-100"
                      autocomplete="off"
                    />
                  </template>
                  <template v-else>
                    {{ item.name }}
                  </template>
                </td>
                <td>
                  <template v-if="mod">
                    <select
                      class="w-100 text-center"
                      v-model="webPage[index].noumenon_id"
                      name="commonSelectInput"
                      style="height: 33px"
                    >
                      <option :value="null">無</option>
                      <option
                        v-for="(option, index) in webPageOption"
                        :value="option.value"
                        :disabled="option.value == ''"
                      >
                        {{ option.text }}
                      </option>
                    </select>
                  </template>
                  <template v-else>
                    {{
                      item.noumenon_id == null
                        ? "無"
                        : webPageName[item.noumenon_id]
                    }}
                  </template>
                </td>
                <template v-for="rightItem in right">
                  <td
                    class=""
                    :class="{ changeAccessStyle: mod }"
                    @click="mod ? changeAccess('mod', index, rightItem) : ''"
                  >
                    <template v-if="item.right.indexOf(rightItem) >= 0">
                      V
                    </template>
                  </td>
                </template>
              </tr>
            </template>
          </tbody>
        </table>
      </div>
    </div>
    <div class="gap-2 d-md-flex justify-content-md-end">
      <template v-if="add == true">
        <button
          type="button"
          class="btn p-0 me-2"
          style="
            color: #fff;
            background-color: #4b8c80;
            width: 6rem;
            height: 2rem;
            font-size: 1.125rem;
          "
          @click="back"
        >
          取消新增
        </button>
        <button
          type="button"
          class="btn p-0"
          style="
            color: #fff;
            background-color: #4b8c80;
            width: 6rem;
            height: 2rem;
            font-size: 1.125rem;
          "
          @click="addWebPageCheck"
        >
          確認新增
        </button>
      </template>
      <template v-else-if="mod == true">
        <button
          type="button"
          class="btn p-0 me-2"
          style="
            color: #fff;
            background-color: #4b8c80;
            width: 6rem;
            height: 2rem;
            font-size: 1.125rem;
          "
          @click="back"
        >
          取消修改
        </button>
        <button
          type="button"
          class="btn p-0"
          style="
            color: #fff;
            background-color: #4b8c80;
            width: 6rem;
            height: 2rem;
            font-size: 1.125rem;
          "
          @click="modWebPageCheck"
        >
          確定修改
        </button>
      </template>
      <template v-else>
        <button
          type="button"
          class="btn p-0 me-2"
          style="
            color: #fff;
            background-color: #4b8c80;
            width: 6rem;
            height: 2rem;
            font-size: 1.125rem;
          "
          @click="addWebPage"
        >
          新增
        </button>
        <button
          type="button"
          class="btn p-0"
          style="
            color: #fff;
            background-color: #4b8c80;
            width: 6rem;
            height: 2rem;
            font-size: 1.125rem;
          "
          @click="modWebPage"
        >
          進行修改
        </button>
      </template>
    </div>
  </div>
</template>

<script>
import { computed, inject, ref, watch } from "vue";
import commonQueryInput from "@/components/commonQueryInput.vue";
import store from "@/store";
export default {
  components: {
    commonQueryInput,
  },
  setup() {
    //getters
    const loginData = computed(() => store.getters["getLogin/get_loginData"]);
    const sideNavPath = computed(
      () => store.getters["sideBarTree/get_sideNavPath"]
    );
    const axiosResult = computed(
      () => store.getters["commonAxios/get_axiosResult"]
    );

    //dispatch
    const methods = {
      axiosAction: async (payload) => {
        await store.dispatch("commonAxios/axiosAction", payload);
      },
      triggerLoadingBar: () => {
        store.dispatch("commonLoadingBar/triggerLoadingBar");
      },
      setTimeoutAlert: (alertText) => {
        store.dispatch("commonAlert/setTimeoutAlert", [alertText]);
      },
    };

    const account = ref(loginData.value.account);
    const username = ref(loginData.value.username);

    const path = inject("path");
    const webPageOption = ref([]);
    const multiInputVal = ref();
    const multiInputItems = ref([
      {
        key: "itemValue",
        label: "網頁編號/名稱",
        type: "selectInputList",
        disableText: "-- 選擇網頁編號/名稱 --",
        options: computed(() => webPageOption.value),
      },
    ]);

    const webPageTable = ref(null);
    const add = ref(false);
    const mod = ref(false);
    const addWebPageData = ref({});
    const orgWebPage = ref({});

    const addWebPage = () => {
      addWebPageData.value = {
        webPage_id: "",
        name: "",
        noumenon_id: null,
        right: [],
      };
      add.value = true;
      mod.value = false;
      webPageTable.value.scrollTo({
        top: 0,
        behavior: "smooth",
      });
    };
    const modWebPage = () => {
      orgWebPage.value = JSON.parse(JSON.stringify(webPage.value));
      add.value = false;
      mod.value = true;
    };
    const back = () => {
      addWebPageData.value = {};
      if (!isEmptyObject(orgWebPage.value)) {
        webPage.value = JSON.parse(JSON.stringify(orgWebPage.value));
      }
      add.value = false;
      mod.value = false;
      delCheckbox.value = [];
    };
    const addWebPageCheck = () => {
      console.log(addWebPageData.value);
      if (addWebPageData.value.webPage_id == "") {
        methods.setTimeoutAlert("編號不可為空");
        return;
      } else if (addWebPageData.value.webPage_id.length > 20) {
        methods.setTimeoutAlert("編號不可超過20位元");
      } else if (addWebPageData.value.name == "") {
        methods.setTimeoutAlert("名稱不可為空");
        return;
      }

      if (addWebPageData.value.noumenon_id == "") {
        addWebPageData.value.noumenon_id = null;
      }

      methods.triggerLoadingBar();
      let params = {};
      params["webPage"] =
        sideNavPath.value.length != 0
          ? sideNavPath.value[sideNavPath.value.length - 1]
          : null;
      params["user"] = loginData.value.account;
      params["vuePage"] = "permissionsetting";
      console.log(path.value);
      params["methods"] = "POST";
      params["whichFunction"] = "AddWebPage";
      params["addWebPageData"] = addWebPageData.value;
      methods.axiosAction(params).then(() => {
        console.log(axiosResult.value);
        let result = axiosResult.value;
        let response = result.Response;
        if (response == "ok") {
          methods.triggerLoadingBar();
          methods.setTimeoutAlert("新增完成");
          queryWebPage(addWebPageData.value.webPage_id);
        } else {
          methods.setTimeoutAlert(response);
          methods.triggerLoadingBar();
        }
      });
    };
    const modWebPageCheck = () => {
      const updateData = {
        webPageDataUpdate: [],
        deletedWebPage: [],
      };

      // 檢查被刪除的頁面
      delCheckbox.value.forEach((id) => {
        const webPageIndex = webPage.value.findIndex(
          (webPage) => webPage.webPage_id === id
        );
        if (webPageIndex !== -1) {
          updateData.deletedWebPage.push(id);
          // 移除被刪除的頁面
          webPage.value.splice(webPageIndex, 1);
          orgWebPage.value.splice(webPageIndex, 1); // 同時也從 orgWebPage 中移除相應的元素
        }
      });

      webPage.value.forEach((item, index) => {
        const orgItem = orgWebPage.value[index];

        if (
          item.name !== orgItem.name ||
          item.noumenon_id !== orgItem.noumenon_id ||
          item.right.join("") !== orgItem.right.join("")
        ) {
          // 如果name或pwd有修改，將該項目添加到webPageDataUpdate中
          updateData.webPageDataUpdate.push(item);
        }
      });

      console.log(updateData);
      if (
        updateData.webPageDataUpdate.length === 0 &&
        updateData.deletedWebPage.length === 0
      ) {
        methods.setTimeoutAlert("無修改項目");
        return;
      }

      methods.triggerLoadingBar();
      let params = {};
      params["webPage"] =
        sideNavPath.value.length != 0
          ? sideNavPath.value[sideNavPath.value.length - 1]
          : null;
      params["user"] = loginData.value.account;
      params["vuePage"] = "permissionsetting";
      params["methods"] = "POST";
      params["whichFunction"] = "UpdateWebPage";
      params["updateData"] = updateData;
      methods.axiosAction(params).then(() => {
        console.log(axiosResult.value);
        let result = axiosResult.value;
        let response = result.Response;
        if (response == "ok") {
          methods.triggerLoadingBar();
          methods.setTimeoutAlert("修改完成");
          orgWebPage.value = {};
          queryWebPage();
        } else {
          methods.setTimeoutAlert(response);
          methods.triggerLoadingBar();
        }
      });
    };

    //判斷是否為空物件
    function isEmptyObject(obj) {
      for (var key in obj) {
        if (obj.hasOwnProperty(key)) {
          return false;
        }
      }
      return true;
    }

    const right = ref(["C", "R", "U", "D"]);
    const webPage = ref([]);
    const webPageName = ref([]);

    const delCheckbox = ref([]);

    const changeAccess = (category = "add", index = 0, type) => {
      if (category == "add") {
        const typeIndex = addWebPageData.value.right.indexOf(type);

        if (typeIndex === -1) {
          addWebPageData.value.right.push(type);
        } else {
          addWebPageData.value.right.splice(typeIndex, 1);
        }
      } else if (category == "mod") {
        const thisWebPage = webPage.value[index];
        const typeIndex = thisWebPage.right.indexOf(type);

        if (typeIndex === -1) {
          thisWebPage.right.push(type);
        } else {
          thisWebPage.right.splice(typeIndex, 1);
        }
      }
    };

    const queryWebPage = (selectValue = undefined) => {
      methods.triggerLoadingBar();
      let params = {};
      params["webPage"] =
        sideNavPath.value.length != 0
          ? sideNavPath.value[sideNavPath.value.length - 1]
          : null;
      params["user"] = loginData.value.account;
      params["vuePage"] = "permissionsetting";
      console.log(path.value);
      params["methods"] = "POST";
      params["whichFunction"] = "QueryWebPage";
      firstQuery.value == false ? (params["firstQuery"] = true) : "";
      selectValue != undefined ? (params["selectValue"] = selectValue) : "";
      methods.axiosAction(params).then(() => {
        console.log(axiosResult.value);
        let result = axiosResult.value;
        let response = result.Response;
        if (response == "ok") {
          let QueryTableData = result.QueryTableData;
          webPage.value = QueryTableData["webPage_data"];
          if (!firstQuery.value) {
            webPageName.value = QueryTableData["webPage_name_data"];
            webPageOption.value = QueryTableData["webPage_option"];
            firstQuery.value = true;
          }
        } else {
          methods.setTimeoutAlert(response);
        }
        back();
        methods.triggerLoadingBar();
      });
    };

    //watch 按查詢鍵回傳所有輸入框的值
    watch(
      multiInputVal,
      (newValue) => {
        console.log(newValue);
        queryWebPage(newValue.itemValue);
      },
      { deep: true }
    );

    const firstQuery = ref(false);
    queryWebPage();

    return {
      username,
      webPageOption,
      multiInputVal,
      multiInputItems,
      webPageTable,
      add,
      mod,
      addWebPageData,
      addWebPage,
      modWebPage,
      back,
      addWebPageCheck,
      modWebPageCheck,
      right,
      webPage,
      webPageName,
      delCheckbox,
      changeAccess,
    };
  },
};
</script>

<style scoped>
thead > tr:nth-child(1) > th {
  background: #4b8c80;
  color: #ffffff;
}
thead > tr:nth-child(2) > th {
  background: #ccc;
  color: #000;
}
.table {
  white-space: nowrap;
}
.table > thead,
.table > thead > tr:nth-child(1) > th:nth-child(1) {
  position: sticky;
  top: 0;
  z-index: 2;
}
.table > thead > tr > th:nth-child(1),
.table > tbody > tr > td:nth-child(1) {
  white-space: normal;
  overflow-wrap: anywhere;
  width: 180px;
  min-width: 180px;
  position: sticky;
  left: 0;
}
.table > thead > tr > th:nth-child(2),
.table > tbody > tr > td:nth-child(2) {
  width: 180px;
  min-width: 180px;
  position: sticky;
  left: 180px;
}
.table > thead > tr > th:nth-child(3),
.table > tbody > tr > td:nth-child(3) {
  white-space: normal;
  overflow-wrap: anywhere;
  width: 180px;
  min-width: 180px;
  position: sticky;
  left: 360px;
}
.table.mod > thead,
.table.mod > thead > tr:nth-child(1) > th:nth-child(1),
.table.mod > thead > tr:nth-child(1) > th:nth-child(2),
.table.mod > thead > tr:nth-child(2) > th:nth-child(3),
.table.mod > thead > tr:nth-child(2) > th:nth-child(4) {
  position: sticky;
  top: 0;
  z-index: 2;
}
.table.mod > thead > tr:nth-child(1) > th:nth-child(2) {
  left: 65px;
}
.table.mod > thead > tr > th:nth-child(1),
.table.mod > tbody > tr > td:nth-child(1) {
  width: 65px;
  min-width: 65px;
  position: sticky;
  left: 0;
}
.table.mod > thead > tr > th:nth-child(2),
.table.mod > tbody > tr > td:nth-child(2) {
  white-space: normal;
  overflow-wrap: anywhere;
  width: 180px;
  min-width: 180px;
  position: sticky;
  left: 65px;
}
.table.mod > thead > tr > th:nth-child(3),
.table.mod > tbody > tr > td:nth-child(3) {
  width: 180px;
  min-width: 180px;
  position: sticky;
  left: 245px;
}
.table.mod > thead > tr > th:nth-child(4),
.table.mod > tbody > tr > td:nth-child(4) {
  white-space: normal;
  overflow-wrap: anywhere;
  width: 180px;
  min-width: 180px;
  position: sticky;
  left: 425px;
}
.changeAccessStyle {
  cursor: pointer;
}
</style>
